export default __webpack_public_path__ + "static/demographics-c4220c97530d41dd3d2f14b44a0d022a.png";